import { css } from "emotion";

import { colors } from "@cobliteam/base-components/src/styles/colors";

export const mapStopActionArea = css`
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid ${colors.gray.light};
`;

export const stopPopupFooterNote = css`
  width: 162px;
`;
